import { message, message as toast } from "antd";
import moment from "moment";

// Currency Symbol
export const curSym = "$";

// Authorizationw
export const pipSetAccessToken = (token) => {
  if (!token) return;
  localStorage.setItem("access-token", token);
};
export const pipGetAccessToken = () => {
  return localStorage.getItem("access-token");
};
export const clearAuth = () => {
  localStorage.removeItem("access-token");
  localStorage.removeItem("users_data");
  message.success("Successfully logged out");
  window.location.reload();
};

// Profile
export const pipSaveProfile = (profile) => {
  if (!profile) return;
  else localStorage.setItem("users_data", JSON.stringify(profile));
};

export const pipGetProfile = () => {
  const profile = localStorage.getItem("users_data");
  return profile ? JSON.parse(profile) : {};
};

// Date View Format
export const pipViewDate = (date) => {
  if (!date) return;
  return moment(date).format("MMM DD, YYYY h:mm A");
};

// Message Handlers
export const pipSuccessMessage = (message) => {
  if (!message) return;
  return toast.success(message);
};

export const pipErrorMessage = (message) => {
  if (!message) return;
  return toast.error(message);
};

export const getSubstring = (str, len, appendStr = "...") => {
  if (!str) return "";
  if (str?.length <= len) return str;
  return str?.substring(0, len) + appendStr;
};

export const checkStatus = (status) => {
  return status != 0 ? true : false;
};

//new date view
export const pipViewDate2 = (date) => {
  if (!date) return;
  return moment(date).format("MMM DD, YYYY");
};

// Time View Format
export const pipTimeView = (time) => {
  if (!time) return;
  return moment(time).format("h:mm A");
};

export const downloadCSV = (data, filename = "users.csv") => {
  if (!data || !data.length) return;

  const headers = [
    "Name",
    "City",
    "Country",
    "Gender",
    "Looking For",
    "Age (In years)",
    "Plan Type",
    "Join Date",
    "No. of times Reported",
    "Facial verification",
    "Status",
  ];

  const rows = data.map((item) => [
    item?.name ?? "",
    item?.city ?? "",
    item?.country ?? "",
    item?.gender ?? "",
    Array.isArray(item?.looking_for)
      ? item.looking_for.join(", ")
      : item?.looking_for ?? "",
    item?.age ?? "",
    item?.account_type ?? "",
    item?.created_at ? new Date(item.created_at).toLocaleDateString() : "",
    item?.report_count ?? 0,
    item?.is_verified == 0
      ? "No Action"
      : item?.is_verified == 1
      ? "Accepted"
      : item?.is_verified == 2
      ? "Pending"
      : "Rejected",
    item?.is_blocked ? "Blocked" : "Active",
  ]);

  const csvContent = [headers, ...rows]
    .map((e) =>
      e.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
